import React from 'react';

/**
 * Mobile-first container that provides the phone-like frame
 * Centers content and adds the scrollable container styling
 */
const MobileContainer = ({ children }) => {
  return (
    <div className="relative min-h-screen-safe w-full flex justify-center items-center bg-background-darker">
      {/* Background Glow Effects */}
      <div className="absolute inset-0 overflow-hidden opacity-30 pointer-events-none">
        <div className="absolute top-[-20%] left-[-10%] w-[60%] h-[60%] rounded-full bg-primary blur-[150px] opacity-10" />
        <div className="absolute bottom-[-20%] right-[-10%] w-[60%] h-[60%] rounded-full bg-blue-600 blur-[150px] opacity-10" />
      </div>

      {/* Main Content Container */}
      <div className="scrollbar-hide relative w-full max-w-[480px] h-screen-safe max-h-[100%] sm:max-h-[900px] bg-background-dark shadow-2xl overflow-y-auto overflow-x-hidden border-x border-white/5 sm:rounded-2xl flex flex-col">
        {children}
      </div>
    </div>
  );
};

export default MobileContainer;
